import React from 'react';

import { ViolationListItemDetail } from '../Common/ViolationListItemDetail';
import { Violation } from "../../types";

type Props = {
    violation: Violation
    imagePopup: (e: any) => void
    showPopupImage: boolean,
    PopupImageSource?:string
};

const Data = ({ violation,imagePopup,showPopupImage,PopupImageSource}: Props) => (
    <div>
        {/* {violation.id ? ( */}
        <ViolationListItemDetail
            id={violation.id}
            imageSource={violation.violationDetail.imageUrl}
            imageSourceSecond={violation.violationDetail.plateImageUrl}
            ViolationType={violation.violationType}
            violationImage={violation.violationImage}
            violationVideoUrl={violation.violationVideoUrl}
            videoSource={violation.violationDetail.videoUrl[0]}
            plateNumber={violation.violationDetail.plateNumber}
            violationDate={violation.violationDetail.violationDate}
            carType={violation.violationDetail.carType}
            color={violation.violationDetail.color}
            imagePopup={imagePopup}
            showPopupImage={showPopupImage}
            PopupImageSource={PopupImageSource}
            speedInfo={violation.speedInfo}
        />
        {/* ): null} */}
    </div>
);

export default Data;


// WEBPACK FOOTER //
// ./src/components/ViolationsHistoryDetails/Data.tsx